module.exports = __webpack_public_path__ + "img/bgp07.20f81bf4.jpg";